import { useMutation } from '@tanstack/react-query';

import { exportRfqAsPdf } from '../../common/api/clients/export.api';

export const useExportRfqMutation = () => {
    return useMutation({ mutationFn: exportRfqAsPdf });
};
